export const content = 'IMPORTANT: READ CAREFULLY';
export const openFile = 'Open';
export const OrderInsights = 'Order Insights';
export const createNewServiceOrder = 'Would you like to create one now?';
export const noServiceOrderSupport = 'No Service Orders Found.  File Status does not support Service Order creation';
export const noActiveServiceOrders = 'No Active Service Orders Found';
export const editServiceOrderMessage =
  'Please include any comments to assist the production team with fulfilling your order.';
export const WindowFeatures = 'popup';
export const orderInsightsInfo =
  'Order Insights will generate pdf report using information from your <a href="./file-info">File Info</a> page and check parties and properties against watchlists, claims databases, vacant land records, identify name mismatches, and more.';
export const serviceOrderSupportMessage =
  '<strong>Just want to view?</strong> To see current insights without creating a new order, visit the <a href="./order-insights">Order Insights</a> page where you can review the analysis and generate a PDF for download if needed.';
export const serviceOrderEditMessage =
  'You are in edit mode. Finish editiing the Service Order to enable all the page features';
export enum ServiceOrdersActions {
  edit = 'Edit',
  view = 'View',
  expandCollapseActive = 'ExpandCollapseActive',
  expandCollapseInActive = 'ExpandCollapseInActive',
  onInactiveToggleChange = 'OnInactiveToggleChange',
}
export enum ServiceOrderStatus {
  orderplaced = 'Order Placed',
  orderdelivered = 'Order Delivered',
  closed = 'Closed',
  cancelled = 'Cancelled',
  openedInError = 'Opened In Error',
  updateDelivered = 'Update Delivered',
  updateRequested = 'Update Requested',
}

export enum ServiceOrderMessage {
  downloading = 'Generating file for download...',
  downloadSuccess = 'Document downloaded successfully.',
  downloadError = 'Download failed. Please try again.',
}

export enum APIStatus {
  pending = 'pending',
  fulfilled = 'fulfilled',
  rejected = 'rejected',
  error = 'error',
  success = 'success',
  loading = 'loading',
}
